<template>
  <div>
    <div class="animated fadeIn container-fluid">
      <b-row>
        <b-col md="12">
          <div class="block-text">
            <b-button
              class="btn-collapse-tips"
              variant="outline-warning"
              @click="showCollapse = !showCollapse"
              >{{ $t("menu.instructions") }}</b-button
            >
          </div>
          <router-link class="link-item" :to="{ name: 'New AccessPoint' }"
            >新增無線熱點 New AccessPoint</router-link
          >
        </b-col>
      </b-row>

      <div class="collapse-tips-area">
        <b-collapse id="map-control-tips" v-model="showCollapse">
          <b-card>
            <ul>
              <li>【 編輯裝置 】 滑鼠左鍵點擊裝置 hashid/名稱</li>
              <li class="err-msg">
                【 開新分頁編輯裝置 】 滑鼠右鍵點擊裝置 hashid/名稱 or
                滑鼠左鍵點擊裝置 icon
              </li>
              <li>
                【 分類按鈕 】
                切換只看某分類的裝置，按鈕分別為：全部、實體、虛擬、清單中所有
                gateway 狀態
              </li>
              <li>
                【 分類搜尋 】
                先點選上方分類按鈕後，再輸入搜尋關鍵字，可以只搜尋該分類內的裝置
              </li>
              <li class="err-msg">【 搜尋裝置 ID 】 使用 id= 來搜尋裝置 ID</li>
              <li>
                【 複製 hashid 按鈕 】 在 hashid 後面有個
                <b-button size="sm" variant="outline-warning"
                  ><i class="fa fa-clone"></i
                ></b-button>
                圖案的黃色小按鈕，點了會複製 hashid 到剪貼簿，card/table
                模式下都有
              </li>
            </ul>
          </b-card>
        </b-collapse>
      </div>

      <b-row>
        <b-col md="6" class="mb-2">
          <b-input-group size="lg">
            <b-input-group-prepend>
              <b-input-group-text>關鍵字</b-input-group-text>
            </b-input-group-prepend>
            <b-form-input v-model="search.keyword"></b-form-input>
            <!-- <b-input-group-append>
                            <b-button variant="success" @click="get_List()">{{ $t('menu.search') }} {{ $t('n.gateway') }}</b-button>
                        </b-input-group-append> -->
          </b-input-group>
        </b-col>

        <b-col md="6" class="mb-2">
          <b-input-group size="lg">
            <b-input-group-prepend>
              <b-input-group-text>Device ID</b-input-group-text>
            </b-input-group-prepend>
            <b-form-input
              type="text"
              class="form-control"
              v-model.trim="search.ids"
              :maxlength="100"
            />
          </b-input-group>
          <div class="text-muted">搜尋複數 ID 請以半形逗點隔開： ex. 1,2,3</div>
        </b-col>

        <b-col md="12">
          <b-form-group class="mt-2 block-md">
            <b-form-checkbox-group v-model="search.statuses" buttons>
              <b-form-checkbox
                v-for="status in admin_Status_List"
                :key="status.value"
                :value="status.value"
                :button-variant="status.buttonVariant"
              >
                {{ $t("status.gateway." + status.value) }}
              </b-form-checkbox>
            </b-form-checkbox-group>
          </b-form-group>
        </b-col>
      </b-row>

      <!-- 阿龜資料讀取畫面 -->
      <div v-if="loading">
        <AgriLoading :showCloud="true" :showAgriGift="true"></AgriLoading>
      </div>

      <!-- 顯示：表格 -->
      <div v-else>
        <b-card>
          <b-row>
            <b-col md="5" xl="4">
              <b-input-group label-cols="5" class="mb-2">
                <b-input-group-prepend>
                  <b-input-group-text>每頁顯示數量</b-input-group-text>
                </b-input-group-prepend>
                <b-form-select
                  v-model="search.per_page"
                  :options="page_options"
                  style="max-width: 120px"
                ></b-form-select>
                <b-input-group-append>
                  <b-input-group-text
                    >{{ $t("menu.data_count") }}：{{
                      search.data_count
                    }}</b-input-group-text
                  >
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col md="7" xl="4">
              <b-input-group class="mb-2">
                <b-input-group-prepend>
                  <b-input-group-text>{{
                    $t("menu.order_by")
                  }}</b-input-group-text>
                </b-input-group-prepend>
                <b-select v-model="search.order_by" class="select-box">
                  <option
                    v-for="(option, idx_option) in list_sort"
                    :key="idx_option"
                    :value="option.value"
                    class="select-item"
                  >
                    {{ option.text }}
                  </option>
                </b-select>
              </b-input-group>
            </b-col>
            <b-col>
              <!-- 分頁 -->
              <div v-if="search" class="justify-content-center">
                <b-pagination
                  v-model="search.current_page"
                  :total-rows="search.data_count"
                  :per-page="search.per_page"
                  aria-controls="records-list"
                  pills
                  align="center"
                ></b-pagination>
              </div>
            </b-col>
          </b-row>

          <div v-if="table_items.length > 0">
            <div class="list-table-result scroll-style-gray overflow-x">
              <b-table
                hover
                small
                responsive="xl"
                :fields="table_fields"
                :items="table_items"
              >
                <!-- A virtual column -->

                <template #cell(hashid)="row">
                  <b-button
                    variant="light"
                    size="sm"
                    class="block-text"
                    :to="{
                      name: 'Edit AccessPoint',
                      params: { deviceID: row.item.hashid },
                    }"
                  >
                    {{ row.item.hashid }}
                  </b-button>
                  <BtnCopyToClipboard
                    :copy_content="row.item.hashid"
                    :btn_text="''"
                    :tooltip_text="'copy hashid'"
                    btn_style="small"
                    :btn_variant="'outline-warning'"
                  >
                  </BtnCopyToClipboard>

                  <img
                    class="btn-indeedee"
                    :src="$config.getAssetsURL('img/brand/sidebar_icon.png')"
                    @click="
                      $config.goTo_Iguanshi('accesspoint', {
                        deviceID: row.item.hashid,
                      })
                    "
                    :alt="'go to IGuanShi: ' + row.item.hashid"
                  />
                </template>

                <template #cell(nickname)="row">
                  <div class="block-text clickable-sm">
                    <span v-if="row.item.nickname">{{
                      row.item.nickname
                    }}</span>
                  </div>
                </template>

                <template #cell(data)="row">
                  <div class="device-row_data-btn-area">
                    <b-button
                      size="sm"
                      variant="outline-success"
                      :to="{
                        name: 'Data AccessPoint',
                        params: { deviceID: row.item.hashid },
                      }"
                    >
                      <i class="fa fa-tachometer block-text"></i>Recoards
                    </b-button>
                  </div>
                </template>

                <template #cell(status)="row">
                  <b-badge
                    :variant="
                      $tools.style.variantStatusButton(
                        'device',
                        row.item.status,
                        false
                      )
                    "
                    >{{ $t("status.device." + row.item.status) }}</b-badge
                  >
                </template>

                <template #cell(details)="row">
                  <b-button
                    size="sm"
                    @click="row.toggleDetails"
                    class="mr-2 btn-warning"
                  >
                    {{ row.detailsShowing ? "Hide" : "Show" }}
                  </b-button>
                </template>
                <template #row-details="row">
                  <div></div>
                  <div class="device">
                    <div class="device-sensor">
                      <div>
                        <i class="fa fa-rss block-text"></i>ICCID：{{
                          row.item.iccid
                        }}
                      </div>
                      <div>
                        <i class="fa fa-map-marker block-text"></i>
                        <span
                          v-if="
                            row.item.latitude == undefined &&
                            row.item.longitude == undefined
                          "
                          class="undefined-msg"
                          >被丟進四次元口袋了</span
                        >
                        <span v-else
                          >{{ row.item.latitude }} ,
                          {{ row.item.longitude }}</span
                        >
                      </div>
                      <br />
                      <b-alert variant="secondary" show>
                        <div class="block-text-sm">
                          <i class="icon-menu"></i>{{ $t("menu.admin_note") }}：
                        </div>
                        <div v-html="row.item.note" class="block-sm"></div>
                      </b-alert>
                    </div>
                  </div>
                  <br />
                </template>
              </b-table>

              <!-- 分頁 -->
              <div v-if="search" class="justify-content-center">
                <b-pagination
                  v-model="search.current_page"
                  :total-rows="search.data_count"
                  :per-page="search.per_page"
                  aria-controls="records-list"
                  pills
                  align="center"
                ></b-pagination>
              </div>
              <div class="text-center">
                {{ $t("menu.data_count") }}：{{ search.data_count }}
              </div>
            </div>
          </div>
          <div v-else>
            <NoData></NoData>
          </div>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import NoData from "@/views/components/NoData";
import AgriLoading from "@/views/components/AgriLoading";
import BtnCopyToClipboard from "@/views/components/Button_CopyToClipboard";

export default {
  components: {
    NoData,
    AgriLoading,
    BtnCopyToClipboard,
  },
  data: function () {
    return {
      loading: false,
      result_list: [],
      timezone: "Asia/Taipei",
      showCollapse: false,

      // 搜尋條件
      query_string: "",
      search: {
        keyword: "",
        data_count: 0,
        per_page: 20,
        current_page: 1,
        statuses: [],
        order_by: "-created_at",
        ids: "",
      },
      list_sort: [
        { value: "-id", text: "id 降序" },
        { value: "id", text: "id" },

        { value: "-deviceid", text: "deviceid 降序" },
        { value: "deviceid", text: "deviceid" },

        { value: "-manufacture", text: "manufacture 降序" },
        { value: "manufacture", text: "manufacture" },

        { value: "-created_at", text: "created_at 降序" },
        { value: "created_at", text: "created_at" },

        { value: "-updated_at", text: "updated_at 降序" },
        { value: "updated_at", text: "updated_at" },
      ],
      page_options: [
        { value: 10, text: 10 },
        { value: 20, text: 20 },
        { vlaue: 50, text: 50 },
        { value: 100, text: 100 },
      ],

      // table
      table_fields: [
        { key: "idx", sortable: true },
        // { key: 'type', sortable: true },
        { key: "hashid", sortable: true },
        { key: "device id", sortable: true },
        { key: "nickname", sortable: true },
        { key: "data", sortable: false },
        { key: "manufacture", sortable: true },
        { key: "status", sortable: true },
        { key: "details", sortable: false },
      ],
      table_items: [],
    };
  },
  mounted() {
    this.timezone = this.$tools.date.getTimezoneNow();
    this.check_QueryURL();
  },
  computed: {
    ...mapState({
      admin_List: (state) => state.accesspoint.accesspoints,
      admin_Status_List: (state) => state.accesspoint.list_status,
    }),
  },
  watch: {
    "search.keyword"() {
      this.get_QueryString();
    },
    "search.statuses"() {
      this.get_QueryString();
    },
    "search.per_page"() {
      this.get_QueryString();
    },
    "search.current_page"() {
      this.get_QueryString();
    },
    "search.order_by"() {
      this.get_QueryString();
    },
    "search.ids"(val) {
      let _split_ids = val.split(",");
      let _list_ids = [];

      _split_ids.forEach((_id) => {
        let _int_id = parseInt(_id);
        if (_int_id && _list_ids.indexOf(_int_id) == -1)
          _list_ids.push(_int_id);
      });
      this.search.ids = _list_ids.join(",");
      this.get_QueryString();
    },

    query_string() {
      if (this.query_string == "")
        window.history.replaceState("", "", location.pathname);
      // 無 query
      else window.history.replaceState("", "", this.query_string);

      this.get_List();
    },
  },
  methods: {
    get_QueryString() {
      let _query_string = "";
      let _query_stack = [];

      if (this.search.keyword != "") {
        _query_stack.push("q=" + this.search.keyword);
      }

      if (this.search.statuses.length > 0) {
        _query_stack.push("statuses=" + this.search.statuses.join(","));
      }

      if (this.search.per_page != null) {
        _query_stack.push("limit=" + this.search.per_page);
      }

      if (this.search.current_page != null) {
        let _skip = (this.search.current_page - 1) * this.search.per_page;
        _query_stack.push("skip=" + _skip);
      }

      if (this.search.order_by != null) {
        _query_stack.push("order_by=" + this.search.order_by);
      }

      if (this.search.ids != "") {
        _query_stack.push("ids=" + this.search.ids);
      }

      if (_query_stack.length > 0) _query_string = "?" + _query_stack.join("&");

      this.query_string = _query_string;
    },

    check_QueryURL() {
      let _url_query = this.$route.query;

      if (_url_query.q != undefined) this.search.keyword = _url_query.q;
      if (_url_query.ids != undefined) this.search.ids = _url_query.ids;
      if (_url_query.statuses != undefined)
        this.search.statuses = _url_query.statuses.split(",");
      if (_url_query.order_by != undefined) {
        // 檢查 sort 是否合法
        let _check_ok = false;
        this.list_sort.forEach((_option) => {
          if (_option.value == _url_query.order_by) _check_ok = true;
        });

        if (_check_ok) this.search.order_by = _url_query.order_by;
      }

      if (_url_query.limit != undefined) {
        // 檢查 limit 是否合法
        let _check_ok = false;
        this.page_options.forEach((_option) => {
          if (_option.value == _url_query.limit) _check_ok = true;
        });

        if (_check_ok) this.search.per_page = _url_query.limit;
      }

      if (_url_query.skip != undefined && _url_query.skip >= 0) {
        // 檢查 skip 是否合法
        let _check_ok = true;
        if (_url_query.skip % this.search.per_page != 0) false;

        if (_check_ok)
          this.search.current_page =
            parseInt(_url_query.skip / this.search.per_page) + 1;
      }

      this.get_QueryString();
    },

    get_List() {
      this.loading = true;
      const settings = {
        query: this.query_string,
        timezone: this.timezone,
      };
      this.$store
        .dispatch("accesspoint/get_List", settings)
        .then((res) => {
          this.loading = false;

          this.search.data_count = res.count;

          let _list_accesspoints = this.admin_List.slice();

          _list_accesspoints.forEach((_accesspoint) => {
            let _hashType = _accesspoint.hashid[0] + _accesspoint.hashid[1];
            _accesspoint["device id"] = _hashType + "-" + _accesspoint.deviceid;
          });

          this.result_list = _list_accesspoints;
          this.arrangeTableData();
        })
        .catch((err) => {
          this.loading = false;
        });
    },

    arrangeTableData() {
      let _items = [];
      this.result_list.forEach((_data, _idx) => {
        let _new_data = this.$tools.data.deepCopy_object(_data); // 複製一份

        _new_data["idx"] = _idx + 1;

        _items.push(_new_data);
      });
      this.table_items = _items;
    },
  },
};
</script>

<style lang="scss" scoped>
.device-data-btn-area {
  float: right;
}
.device-data-btn {
  display: inline-block;
  margin: 0px 5px 20px 10px;
  padding: 2px 5px;
}
</style>

